import React, { Component } from 'react'

// Styles
import './index.scss'

// Components
import Form from './Form'

class ContactUs extends Component {
  render = () => {
    return (
      <div className="contact-us-parent">
        <div className="page-banner bg-page-banner vh-center">
          <div className="banner-content">
            <h2>Contact Us</h2>
          </div>
        </div>

        <div className="main container">
          <div style={{ marginTop: '4rem', marginBottom: '4rem' }}>

            <div className="flex form-detail lg-col-flex v-center">

              <div className="c-padd left">
                <div className="form-border">
                  <div className="inner">
                    <p className="c-padd">Would you prefer to have EIDIM contact you?</p>
                    <p style={{ paddingTop: '0', paddingBottom: '0', marginBottom: '1rem' }}>Send us a request by completing the below and we’ll get back to you!</p>
                    <Form />
                  </div>
                </div>
              </div>


              <div className="c-padd right">
                <div className="info">
                  <div className="flex lg-col-flex">
                    <div>
                      <h5 className="c-padd">For Email Queries</h5>
                      <ul className="list-detail">
                        <li><span>General:</span> <a href="mailto:contact@eidim.com">contact@eidim.com</a></li>
                        <li><span>Sales : </span><a href="mailto:order@eidim.com">order@eidim.com</a></li>
                        <li><span>Service Requests :</span> <a href="mailto:support@eidim.com">support@eidim.com</a></li>
                        <li><span>Financial : </span><a href="mailto:accounting@eidim.com">accounting@eidim.com</a></li>
                      </ul>

                      <h5 className="c-padd">Call Us</h5>
                      <ul className="list-detail">
                        <li><span>Direct</span>: 562-777-1009</li>
                        <li><span>Toll Free Number</span>: 877.77-EIDIM (34346)</li>
                      </ul>
                    </div>

                    <div>
                      <h5 className="c-padd">Locations</h5>
                      <ul className="list-detail">
                        <li>
                          <span>NorCal</span><br />
                      649 Dromana Ct. <br />
                      San Ramon, CA 94582 <br />
                      Tel: 925-452-6272 <br />
                      Toll Free Number: 877.77-EIDIM (34346)
                    </li>

                        <li style={{ marginTop: '1rem' }}>
                          <span>SoCal - Headquarters</span><br />
                        6905 Oslo Cir. #J <br />
                        Buena Park, CA 90621 <br />
                        Tel: 562 - 777 – 1009 <br />
                        Toll Free Number: 877.77-EIDIM (34346) <br />
                        Fax: 562 - 777 – 9120
                      </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="info">
                  <h5 className="c-padd">Careers</h5>
                  <h6>Be part of our growing team!</h6>
                  <ul className="list-detail">
                    <li style={{ textAlign: 'justify' }}><span>AV/IT Programmer:</span> Computer or related bachelor’s degree. 1-2 years of experience. Mail resume to EIDIM GROUP, INC., 6905 Oslo Circle Suite J, Buena Park, CA 90621</li>
                    <li style={{ textAlign: 'justify' }}><span>Management Analyst:</span> Master’s in Business Admin or related. Mail resume to EIDIM GROUP, INC., 6905 Oslo Circle Suite J, Buena Park, CA 90621.</li>
                  </ul>
                </div>

              </div>


            </div>

          </div>
        </div>

      </div >
    )
  }
}

export default ContactUs